import { t } from './index';

/** API `value` is English; map to i18n keys under `chat.pickupModal.parentRelation.*` */
const NORMALIZED_TO_KEY: Record<string, string> = {
  mother: 'Mother',
  father: 'Father',
  grandmother: 'Grandmother',
  grandfather: 'Grandfather',
  uncle: 'Uncle',
  aunt: 'Aunt',
  sister: 'Sister',
  brother: 'Brother',
  other: 'Other',
};

export function translateParentRelationLabel(apiValue: string): string {
  const trimmed = apiValue.trim();
  const key = NORMALIZED_TO_KEY[trimmed.toLowerCase()];
  if (!key) return trimmed;
  return t(`chat.pickupModal.parentRelation.${key}`, trimmed);
}
